import React from 'react'

const MenuIcon = () => (
    <svg width="24px" height="16px" viewBox="0 0 24 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>568E5E72-9041-401A-9D77-581365315EEC</title>
    <desc>Created with sketchtool.</desc>
    <g id="Mobile" stroke="none" stroke-width="1" fill="none" fillRule="evenodd" stroke-linecap="round">
        <g id="Mobile-/Dashboard---Empty-state" transform="translate(-312.000000, -27.000000)" stroke="#0F0828" strokeWidth="1.4">
            <path d="M312,27.7272727 L336,27.7272727 L312,27.7272727 Z M312,42.2727273 L336,42.2727273 L312,42.2727273 Z M312,35 L336,35 L312,35 Z" id="Combined-Shape"></path>
        </g>
    </g>
</svg>
)

export default MenuIcon